/**
 * App 进入后台/回到前台时派发全局事件，供 BGM、挨饿音效等统一暂停/恢复。
 * - wk-app-background：应停止播放（用户切到其它 App 或回主屏幕）
 * - wk-app-foreground：若之前在播则恢复
 */
import {
  handleAppAudioBackgroundSfx,
  handleAppAudioForegroundSfx,
} from './soundEffect';
import { WK_APP_BACKGROUND, WK_APP_FOREGROUND } from './appAudioEvents';

export { WK_APP_BACKGROUND, WK_APP_FOREGROUND };

export function initAppAudioLifecycle() {
  if (typeof window === 'undefined' || window.__wkAppAudioLifecycleInit) {
    return;
  }
  window.__wkAppAudioLifecycleInit = true;

  const dispatch = (name) => {
    try {
      window.dispatchEvent(new CustomEvent(name));
    } catch (e) {}
  };

  const onVisibility = () => {
    const hidden = document.visibilityState === 'hidden' || document.hidden;
    if (hidden) {
      dispatch(WK_APP_BACKGROUND);
      handleAppAudioBackgroundSfx();
    } else {
      dispatch(WK_APP_FOREGROUND);
      handleAppAudioForegroundSfx();
    }
  };

  // 仅依赖 visibilitychange，避免与 pagehide/pageshow 重复派发
  document.addEventListener('visibilitychange', onVisibility);
}
